import React, { useState, useEffect, useRef } from 'react';
import ActionComponent from './ActionComponent';
import { useNavigate } from 'react-router-dom';
import _, { keys } from 'lodash';
import DynamicSearchBar from './../../components/common/SearchBar';
import OverlayComponent from './OverlayComponent';
import SearchableDropdownComponent from '../../components/common/SearchableDropDown';
import DataTable from '../../components/common/CommonDataTable';
import OverlayCard from '../../components/common/OverlayCard';
// import data from '../../sampledata.json';
// import { UserList as data } from '../../constants/index';
import Button from './../../components/common/Button';
import CreateNewUser from './CreateNewUser';
import Pencil from './../../assets/svg/pencil.svg'
import PlusSvgIcon from './../../assets/svg_main/plus.svg';
import SettingIcon from './../../assets/svg_main/settings.svg';
import CrossIcon from '../../assets/svg_main/CrossIconBlack.svg';
import axios from '../../utils/axiosExt';
import endpoints from '../../config/endpoints';
import { useDispatch } from 'react-redux';
import { resetForm } from '../../store/actions/userManagementAction';
import profilePic from './../../assets/png/default_profile.png';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import fetchImageCacheImage from './../../utils/fetchImageCacheImage';
import FirstNameComponent from './FirstNameComponent';
import DownloadModal from '@components/common/DownloadModal';
import DownArrow from '@assets/svg/download-01.svg';
import json2xls from 'json-as-xlsx';
import { PagePermission} from './../../services/usePermission';
import Auth from './../../utils/auth';
import './UserManagement.css';
import { decodeWithKeyAndShift } from '@utils/base64Utils';
import { additionalColumnsFormoduleGrid, userManagementColumnHeader } from '@constants/appConstants';
import { handleDynamicColumnForGird } from '@utils/commonUtils';
import InfoBar from '@components/common/InfoBars';
interface objectType {
  [key: string]: any;
}

//setting initial checkbox value to true
let filterCheckBox: objectType = {};
let dropdowndata: objectType = {};

const style = {
  singleValue: (baseStyles: any) => ({
    ...baseStyles,
    fontSize: '12px',
    color: '#797979',
    textAlign: 'center',
    padding: '5px 10px',
  }),
  option: (baseStyles: any, state: any) => ({
    ...baseStyles,
    fontSize: '12px',
    color: state.isFocussed ? '#FFF' : '#797979',
    '&:hover': {
      color: '#FFF',
    },
  }),
  menu: (style: any) => ({
    ...style,
    maxHeight: 250,
  }),
  menuList: (style: any) => ({
    ...style,
    maxHeight: 250,
    overFlowY: 'auto',
  }),
  placeholder: (base: any, state: any) => ({
    ...base,
    marginTop: 5,
    marginLeft: 5,
    color: 'rgba(179, 179, 179, 1)',
    fontWeight: 400,
    fontSize: 12,
    display: state.isFocused && 'none',
  }),
  multiValue: (base: any, state: any) => ({
    ...base,
    minWidth: '55px',
  }),
  valueContainer: () => ({
    display: 'flex',
    flexWrap: 'nowrap',
    overflow: 'overlay',
    marginLeft: 5,
    fontSize: 12,
  }),
};

interface useType {
  [key: string]: any
}
const renderTooltip = (text:any) => (
  <Tooltip className='tooltip-outer' style={{position:"fixed"}}

    >{text}</Tooltip>
);
const shouldRTooltip = (text: any, maxLength = 20) => {
  return text?.length > maxLength;
};
const renderCell = (text: any) => {
  return shouldRTooltip(text) ? (
    <OverlayTrigger placement="bottom" overlay={renderTooltip(text)}>
      <span
        className="text-truncate d-inline-block"
        style={{ maxWidth: '90%' }}
      >
        {text}
      </span>
    </OverlayTrigger>
  ) : (
    <span> {text}</span>
  );
};

const constructActionData = (dataList: any) => {
  return dataList.map((data: any) => {
    return {
      ...data,
      first_name: {
        value: data.first_name,
        url: data.url,
        type: 'component',
        component: FirstNameComponent,
      },
      Action: {
        type: 'component',
        component: ActionComponent,
      },
    };
  }).reverse();
};

const UserManagement = () => {
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [gridData, setGridData] = useState<any[]>([]);
  const [eventKeyval, seteventKeyval] = useState<any[]>([]);
  const [dataExport, setDataExport] = useState<any[]>([]);
  const [checkboxValue, setCheckboxValue] = useState<any>({});
  const [show, setShow] = useState(false);
  const [modal, setModal] = useState<boolean>(false);
  const [imageToBeFetchedAfterMount, setImageToBeFetchedAfterMount] = useState<any>([]);
  const [dropDownFilterList, setDropDownFilterList] = useState<any>({});
  const [closeDownloadModal,setCloseDownloadModal]=useState<boolean>(false)
  const [isLoading,setIsLoading]=useState<boolean>(false)
  const canCreateUser = PagePermission("UserMgmt", "UserMgmt_CrPg");
  const [showSearchWarning, setShowSearchWarning] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');

  const handleSearchChange = _.debounce((value: string) => {
    setSearchTerm(value);
  }, 0);

  const hasNumber = /\d/.test(searchTerm);
  const hasLetter = /[A-Za-z]/.test(searchTerm);
  const hasSpace = /\s/.test(searchTerm);
  const hasSpecialChar = /[^a-zA-Z0-9 ]/.test(searchTerm);

  const handleSearch = () => {
    const trimmedSearchTerm = searchTerm.trim();
    setSearchTerm(trimmedSearchTerm);
    // If empty search term
    if (!trimmedSearchTerm.length) {     
      setShowSearchWarning(true);
      setErrorMessage('Please search either by First Name or by Mobile Number (10 digits) / HPR ID (14 digits) / ABHA Number (14 digits).');
      return
    }

    // Case 1: Mixed letters and numbers (invalid)
    if (hasNumber && hasLetter) {
      setShowSearchWarning(true);
      setErrorMessage('Please search either by First Name or by Mobile Number (10 digits) / HPR ID (14 digits) / ABHA Number (14 digits).');
      return;
    }

    // Case 2: Only letters (First Name search)
    if (hasLetter && !hasNumber) {
      if (trimmedSearchTerm.length < 3) {
        setShowSearchWarning(true);
        setErrorMessage('Please enter at least 3 characters to search by First Name.');
        return;
      }
      setShowSearchWarning(false);
      setErrorMessage('');
      filterFetch(trimmedSearchTerm);
      return;
    }

    // Case 3: Only numbers (Mobile/HPR ID/ABHA Number search)
    if (hasNumber && !hasLetter) {
      const isValidLength = trimmedSearchTerm.length === 10 || trimmedSearchTerm.length === 14;
      const hasInvalidChars = hasSpace || hasSpecialChar;

      if (!isValidLength || hasInvalidChars) {
        setShowSearchWarning(true);
        setErrorMessage('Please enter a valid Mobile Number (10 digits) / HPR ID (14 digits) / ABHA Number (14 digits).');
        return;
      }
      setShowSearchWarning(false);
      setErrorMessage('');
      filterFetch(trimmedSearchTerm);
      return;
    } 

    setShowSearchWarning(true);
    setErrorMessage('Please enter a valid search term.');
  };

  const navigate = useNavigate();
  const userDetails = localStorage.getItem('userDetails');
  const decodedUserData = JSON.parse(decodeWithKeyAndShift(userDetails));
  const Columnheader=decodedUserData?.usertype_code
  ? JSON.parse(JSON.stringify(handleDynamicColumnForGird(decodedUserData?.usertype_code, JSON.parse(JSON.stringify(userManagementColumnHeader)), additionalColumnsFormoduleGrid.columnsBefor.facility_type, additionalColumnsFormoduleGrid.pages.user_management)))
  : JSON.parse(JSON.stringify(userManagementColumnHeader));
  const tempDataForFilter = useRef<any[]>([]);
  const dropDownKeys = _.filter(
    Columnheader,
    (filterList) => filterList.filterRequired,
  );

  useEffect(() => {
    if(imageToBeFetchedAfterMount.length > 0) {
      const result = [];
      for(let i = 0; i< imageToBeFetchedAfterMount.length; i += 10) {
        result.push(imageToBeFetchedAfterMount.slice(i, i + 10));
      }
      result.map((ids:any) => fetchImageCacheImage(ids));
      setImageToBeFetchedAfterMount([]);
    }

  }, [imageToBeFetchedAfterMount]);
  
  const formatData = async (res: any) => {
    for(let i=0;i<res.data.data.length;i++){
      let rolesStr='';
      if(res?.data?.data[i]?.roles !==null){
      for(let j=0;j<res?.data?.data[i]?.roles?.length;j++){
        if(rolesStr===''){
          rolesStr=res?.data?.data[i]?.roles[j]
        }
        else{
          rolesStr=rolesStr+' , '+res?.data?.data[i]?.roles[j]
        }
      }
      res.data.data[i].roles=rolesStr
    }
    let facilityTypeStr =''
    if(res?.data?.data[i]?.facility_type !==null){
      for(let j=0;j<res?.data?.data[i]?.facility_type?.length;j++){
        if(facilityTypeStr===''){
          facilityTypeStr=res?.data?.data[i]?.facility_type[j]
        }
        else{
          facilityTypeStr=facilityTypeStr+' , '+res?.data?.data[i]?.facility_type[j]
        }
      }
      res.data.data[i].facility_type=facilityTypeStr
    }
    let facilityNameStr =''
    if(res?.data?.data[i]?.facility_name !==null){
      for(let j=0;j<res?.data?.data[i]?.facility_name?.length;j++){
        if(facilityNameStr===''){
          facilityNameStr=res?.data?.data[i]?.facility_name[j]
        }
        else{
          facilityNameStr=facilityNameStr+' , '+res?.data?.data[i]?.facility_name[j]
        }
      }
      res.data.data[i].facility_name=facilityNameStr
    }
    
    }   
    setDataExport(res?.data?.data); 
    dropDownKeys.forEach((item, idx) => {

      const option = _.map(_.uniq(_.map(res.data.data, item.key)), (i) => {
        if(i){
        return { value: i, label: i };
        }
      });
      const options=option.filter((item:any)=>item!==undefined);

      dropdowndata = {
        ...dropdowndata,
        [item.key]: options,
      };
      filterCheckBox = {
        ...filterCheckBox,
        [item.key]: idx < 3,
      };
    });
    if(res?.data?.data) {
      await fetchImageFormServer(res?.data?.data);
    }
    let modifiedData: any[] = constructActionData(res.data.data);
    modifiedData = modifiedData.map((ele: any) => {
      return {
        ...ele,
        hpr_abha_id : ele.abha_id ?? ele.hpr_id ?? '',
        urban_or_rural: ele.urban_or_rural ? `${ele.urban_or_rural.charAt(0).toUpperCase() + ele.urban_or_rural.slice(1)}` : ''
      }
    });
    tempDataForFilter.current = modifiedData;
    const filterlistfromSession = sessionStorage.getItem('userFilter');
    const parseToObject = filterlistfromSession ? JSON.parse(filterlistfromSession) : null;
    parseToObject ? setCheckboxValue({ ...parseToObject }) : setCheckboxValue({ ...filterCheckBox });
    setGridData(modifiedData.reverse());
    setIsLoading(false);
  }

  const fetchImageFormServer = async (userList:any) => {
    if (!Array.isArray(userList) || userList.length === 0) {
      return;
    }
    const data:string[] = [];
    userList.forEach((user:any)=> {
      data.push(user.user_id);
    });
    return fetchImageCacheImage(data?.splice(0, 10)).then(() => {
      setImageToBeFetchedAfterMount(data);
      return Promise.resolve();
    });
  }

  const initialFetch =async () => {
    setIsLoading(true);
    setShowSearchWarning(false);
    try {
      const userTypeId = localStorage.getItem('userTypeId');
      const getAllUsersPayload={
        p_usertype_id: userTypeId,
        p_st_id: null,
        p_dist_id: null,
        p_ulb_id: null,
        p_sub_dist_id: null,
        p_block_id: null,
        p_health_block_id: null,
        p_sub_division_id: null,
        p_vill_id: null,
        p_ward_id: null,
      }
      const res = await axios.get(`${endpoints.getAllUsersByHierarchy}`, Auth.loggedInWithJSON());     
      formatData(res);
      
    } catch (error:any) {
      setIsLoading(false);
      
    }
  }

  useEffect(() => {
    if (searchTerm.length === 0) {
      initialFetch();
    }
  }, [searchTerm])

  const filterFetch =async (trimmedSearchTerm: string) => {
    setIsLoading(true);
    try{
      const userTypeId = localStorage.getItem('userTypeId');
      const getSearchUsersPayload={
        p_name_search : hasLetter?trimmedSearchTerm:null,
        p_user_id : userTypeId,
        p_abha_hpr_search : trimmedSearchTerm?.length===14?trimmedSearchTerm:null,
        p_mob_search : trimmedSearchTerm?.length===10?trimmedSearchTerm:null,
      }

      const res = await axios.post(`${endpoints.getSearchUsersByHierarchy}`,getSearchUsersPayload, Auth.loggedInWithJSON());
      formatData(res);
    }
    catch(error:any){
    setIsLoading(false);
      
    }
  }

  useEffect(() => {
    const list = getDropDownOptions(gridData);
    setDropDownFilterList({ ...list});
  }, [gridData]);


  const filterLoop = (dataList: any[], key: string, keyFilter: string[]) => {
    const tempData: any[] = [];
    dataList.forEach((dataValue: any) => {
      const isFilter = key === 'first_name' ? keyFilter.find((val: any) => val === dataValue[key].value): keyFilter.find((val) => val === dataValue[key])
      if(isFilter) {
        tempData.push(dataValue);
      }
    });
    return tempData;
  };
  
  const applyFilter = (eventKey: any, index: number, eValue: any) => {
    const updatedValues = [...eventKeyval];
    updatedValues[index] = eventKey;
    seteventKeyval(updatedValues);
    let tempData: any = [...tempDataForFilter.current];
    const keyNames = Object.keys(filterCheckBox);
    updatedValues.forEach((keyFilter: any, i: number) => {
      const key = keyNames[i];
      if (keyFilter && keyFilter.length >= 1) {
        tempData = filterLoop(tempData, key, keyFilter);
      }
    });
    setGridData(tempData);
  };

  const clearFilter = () => {
    seteventKeyval([]);
    setGridData(tempDataForFilter.current);
  };

  const onChangeCheckbox = (list: any) => {
    setCheckboxValue({ ...list });
    sessionStorage.setItem("userFilter", JSON.stringify({ ...list }));
    setShow(false);
  };

const getDropDownOptions = (data:any) => {
  let dropdowndataValue = {};
  dropDownKeys.forEach((item, idx) => {
    const itemMap = _.map(data, (itemKey) => {
      if(itemKey[item.key] && itemKey[item.key].type == 'component') {
        return itemKey[item.key].value
      } else {
        return itemKey[item.key] 
      }
    });
    const uniquList = _.uniq(itemMap);

    const option = _.map(uniquList, (i) => {
      if(i){
        if(i.type == 'component') {
          return { value: i.value, label: i.value };
        } else {
          return { value: i, label: i };
        }
      }
    });
    const options=option.filter((item:any)=>item!==undefined);

    dropdowndataValue = {
      ...dropdowndataValue,
      [item.key]: options,
    };
  });
  return dropdowndataValue;
}

  const renderFilter = () => {
    return dropDownKeys.map((dropdata, index) => {
      const selectedDropdownValue =
        eventKeyval[index] &&
        eventKeyval[index].map((key: string) => ({
          value: key,
          label: key,
        }));
      if (!checkboxValue[dropdata.key]) return;
      return (
        <>
          <SearchableDropdownComponent
            // options={dropdowndata[dropdata.key]}
            options={dropDownFilterList[dropdata.key]}
            placeHolder={dropdata.name}
            multipleSelection={true}
            onChange={(value) => applyFilter(value, index, dropdata.key)}
            dropDownType="entered"
            dropLabelName={dropdata.name}
            dropDownDisable={false}
            ifRequired={false}
            dropdownsearchable={true}
            isClearable={false}
            className={'user-filter-dropdown'}
            style={style}
            value={selectedDropdownValue ? selectedDropdownValue : null}
          />
        </>
      );
    });
  }

  const addUser = () => {
    navigate(`/user-management/create`);
  };
  const dispatch=useDispatch();

  const closeModal = () => {
    setModal(false);
    initialFetch();
    dispatch(resetForm());
  };
  const excelData = dataExport.map((item, index) => ({
    serialNo: index + 1,
    ...item,
    hpr_abha_id : item.abha_id ?? item.hpr_id ?? '',
  }));
  const dataToExportExcel = [
    {
      sheet: 'User Detail Report',
      columns: [
        { label: 'Sl.No.', value: 'serialNo' },
        { label: 'First Name', value: 'first_name' },
        { label: 'Last Name', value: 'last_name' },
        { label: 'Mobile Number(User ID)', value: 'mob' },
        { label: 'Designation Name', value: 'user_designation_name' },
        { label: 'User Type Name', value: 'usertype_name' },
        { label: 'User Status', value: 'user_status' },
        { label: 'Health Facility Type', value: 'facility_type' },
        { label: 'Health Facility Name', value: 'facility_name' },
        { label: 'ID', value: 'hpr_abha_id' },
        { label: 'Roles', value: 'roles' },
      ],
      content: excelData,
    },
  ];
 

  const downloadClick=()=>{ 
    json2xls(dataToExportExcel, {
      fileName: 'User Detail Report',
      extraLength: 3, // A bigger number means that columns will be wider
    });
   
   }
  const onCloseDownloadModal=(value:boolean)=>{
    if(value){
      setCloseDownloadModal(false);
    }
    else{
      setCloseDownloadModal(false);
    }
  }
  return (
    <div className="user-management-details">
      <div className="search-add-user">
        <div className='search-user-section'>
          <DynamicSearchBar
            onChange={handleSearchChange}
            placeHolder={'Search by First Name, Mobile Number, HPR ID, ABHA Number'}
            disabled={false}
            className="user-search"
            iconNeeded={true}
            value={searchTerm}
          />
          <Button
            onClick={handleSearch}
            disabled={false}
            id=""
            buttonName='Search'
            colorType='previousWithBorder'
            icon=''
          />
        </div>
        {canCreateUser && (
          <Button
            onClick={addUser}
            disabled={false}
            id="add-user"
            buttonName={'Add User'}
            colorType={'primary'}
            icon={<PlusSvgIcon />}
            iconPosition={'left'}
          />
        )}
      </div>
      <div className='warning_info_bar_for_search'>
        {showSearchWarning && <InfoBar  className="confirm_card_infobar" variant={'warning'}  message={errorMessage}/>} 
      </div>
      <div className="user-filter">
        <div className="user-filter-label-icon">
          <h6 className="user-filter-label">FILTERS</h6>
          
          <div className='download_symbol_css'>
          <DownArrow className='down_arrow_cursor' onClick={downloadClick}/>
          <OverlayCard
            show={show}
            setShow={setShow}
            triggerComponent={show? <CrossIcon className="user-cross-icon"/>:<SettingIcon className="user-setting-icon" />}
            trigger="click"
            overlayComponent={OverlayComponent(
              dropDownKeys,
              onChangeCheckbox,
              checkboxValue,
            )}
            placement="bottom-end"
          />
          </div>
        </div>
  
        <div className="filter">
          {dropDownKeys && dropDownFilterList && renderFilter()}
          {/* {Object.values(checkboxValue).includes(true) && */}
          {eventKeyval?.some((filter) => filter?.length > 0) &&
           (
            <Button
              onClick={clearFilter}
              disabled={false}
              id="user-filter-clear"
              buttonName={'Clear Filter'}
              colorType={'save'}
              icon={''}
              iconPosition={''}
            />
          )}
        </div>
      </div>
      <div className="user-table">
        {isLoading ? <div className="loader usermgmt_grid_loader">Loading</div> :
        <DataTable
          data={gridData}
          itemsPerPage={[10,20,30,40,50]}
          height={'300px'}
          searchTerm={searchTerm}
          columnHeader={Columnheader}
          gridFor={'user'}
        />
        }
      </div>
    </div>
  );
};

export default UserManagement;
